// extracted by mini-css-extract-plugin
export default {"product-catalog":"ProductCatalog_product-catalog__1jIMl"};